import { DotsThree } from '@phosphor-icons/react'
import useSessionStore from 'Context/useSessionStore'
import { countDecimalsAndAdd0, formatAmount } from 'Utils/helperFunctions'
import { PERMISSION_BY_ROLE } from 'Utils/permissionByRol'
import { COLOR_BLACK } from 'constant/colors'
import { PROJECT_DETAILS_ROUTER } from 'constant/router'
import { Link } from 'react-router-dom'
import { TABS_PROJECT } from 'Pages/Projects'
import { DropdownMenuActions } from 'Organisms/DropdownMenuActions'

const clampPercent = (value, total) => {
  if (!total || total <= 0) return 0
  return Math.min(100, Math.max(0, (value / total) * 100))
}

const TableListProject = ({ projectList, activeTab, onEdit, onActive, onDeactive, onDelete }) => {
  const { user } = useSessionStore((state) => ({ user: state.user }))

  const OPTIONS_MENU = [
    {
      id: 1,
      actions: [
        activeTab === TABS_PROJECT.ACTIVE.name &&
          {
            id: 1,
            onClick: ({ element }) => onEdit(element.id),
            name: 'Edit',
            elementId: 'editProject'
          },
        activeTab === TABS_PROJECT.ARCHIVED.name &&
          {
            id: 2,
            onClick: ({ element }) => onActive(element.id),
            name: 'Reactivate',
            elementId: 'reactivateProject'
          }
      ]
    },
    {
      id: 2,
      actions: [
        activeTab === TABS_PROJECT.ACTIVE.name && {
          id: 3,
          name: 'Deactivate',
          onClick: ({ element }) => onDeactive(element.id),
          styles: 'text-danger',
          elementId: 'deActivateProject'
        },
        activeTab === TABS_PROJECT.ARCHIVED.name &&
          {
            id: 4,
            name: 'Delete',
            onClick: ({ element }) => onDelete(element.id),
            styles: 'text-danger',
            elementId: 'deleteProject'
          }
      ]
    }
  ]

  const showCosts = PERMISSION_BY_ROLE.PROJECT.TABLE.COLUNM_COST.includes(user.role)

  return (
    <div className="card mb-3 p-4 projects-card">
      <div className="table-responsive projects-card">
        <table className="table align-middle">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Budget</th>
              <th scope="col" />
              <th scope="col">Spent</th>
              <th scope="col">Remaining</th>
              {showCosts && <th scope="col">Costs</th>}
              {PERMISSION_BY_ROLE.PROJECT.TABLE.COLUNM_ACTIONS.includes(user.role) && <th scope="col" />}
            </tr>
          </thead>
          <tbody>
            {projectList.map((project) => {
              const unit = project.budget_unit ?? null
              const spentUnit = unit ?? 'hours'
              const hasBudget = project.budget_configured && project.budget_value > 0
              const overrun = hasBudget && project.spent_value > project.budget_value
              const remaining = project.remaining_value

              let budgetCell = '—'
              if (unit !== null) {
                budgetCell = project.budget_configured
                  ? formatAmount({ value: project.budget_value, unit })
                  : <span className="form-text">Not set</span>
              }

              return (
                <tr key={project.id}>
                  <td className="text-no-wrap">
                    <Link to={PROJECT_DETAILS_ROUTER({ projectId: project.id })}>
                      {`${project.code ? `[${project.code}]` : ''}`} {project.name}
                    </Link>
                    {project?.client?.name && (
                      <span className="form-text d-block">{project.client.name}</span>
                    )}
                  </td>

                  <td className="text-no-wrap">
                    {budgetCell}
                    {project.period?.label && (
                      <span className="form-text d-block">{project.period.label}</span>
                    )}
                  </td>

                  <td>
                    {hasBudget && (
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <div
                            style={{ width: '100px' }}
                            className="progress"
                            role="progressbar"
                            aria-label="Budget used"
                            aria-valuenow={clampPercent(project.spent_value, project.budget_value)}
                            aria-valuemin="0"
                            aria-valuemax="100">
                            <div
                              className="progress-bar"
                              style={{
                                width: `${clampPercent(project.spent_value, project.budget_value)}%`,
                                backgroundColor: '#016A67'
                              }}
                            ></div>
                            {overrun && (
                              <div
                                className="progress-bar"
                                style={{
                                  width: `${clampPercent(project.spent_value - project.budget_value, project.budget_value)}%`,
                                  backgroundColor: '#BC5776ff'
                                }}
                              ></div>
                            )}
                          </div>
                        </div>
                        <div className="px-0 col-auto">
                          <span className="small">
                            {countDecimalsAndAdd0({ number: (project.spent_value / project.budget_value) * 100 })}%
                          </span>
                        </div>
                      </div>
                    )}
                  </td>

                  <td className={unit === null ? 'form-text' : ''}>
                    {formatAmount({ value: project.spent_value, unit: spentUnit })}
                  </td>

                  <td className={remaining != null && remaining < 0 ? 'text-danger' : ''}>
                    {formatAmount({ value: remaining, unit })}
                  </td>

                  {showCosts && <td>{formatAmount({ value: project?.cost ?? 0, unit: 'money' })}</td>}

                  {PERMISSION_BY_ROLE.PROJECT.TABLE.COLUNM_ACTIONS.includes(user.role) && (
                    <td className="text-end">
                      <DropdownMenuActions options={OPTIONS_MENU} element={project} icon={<DotsThree size={18} color={COLOR_BLACK} weight="bold" />} type='secondary' idBtn='menuProject' />
                    </td>
                  )}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TableListProject
